import {
  PreScreenQuestionBank,
} from '../../../../../../../utils/types/assessment_types';
import { PreQualQuestion } from '../../../../../../../utils/types/JobOpenings';
import { IBankQuestionOption, PreQualQuestionType } from '../interfaces';

/**
 * Generates unique key for questions
 */
export const generateUniqueKey = (): string => {
  return `${Date.now().toString(36)}-${Math.random().toString(36).substring(2)}`;
};

/**
 * Maps question type from question bank to pre-qual question type
 */
export const mapBankQuestionTypeToPreQualType = (
  bankType: string,
): PreQualQuestionType => {
  if (bankType === 'numeric') return 'number';
  if (bankType === 'video') return 'video-answer';
  return bankType as PreQualQuestionType;
};

/**
 * Returns formatted question type label
 */
export const getQuestionTypeLabel = (
  value: string,
  typeOptions: { label: string; value: string }[],
): string => {
  const found = typeOptions.find((type) => type.value === value);
  return found ? found.label : value.replace('-', ' ');
};

/**
 * Checks if question text already exists in the question list
 */
export const isDuplicateQuestion = (
  questions: PreQualQuestion[],
  candidateQuestion: string,
): boolean => {
  const normalizedCandidate = candidateQuestion.trim().toLowerCase();
  return questions.some(
    (q) => q.question.trim().toLowerCase() === normalizedCandidate,
  );
};

/**
 * Transforms question bank API items into select options
 */
export const formatBankQuestionsToOptions = (
  bankQuestions: PreScreenQuestionBank[],
): IBankQuestionOption[] => {
  return bankQuestions.map((question) => ({
    value: question.id || '',
    label: question.question,
    typeLabel:
      question.questionType === 'numeric'
        ? 'Numeric'
        : question.questionType.replace('-', ' '),
    raw: question,
  }));
};
